// extracted by mini-css-extract-plugin
export var icon = "_a3-3";
export var subtitle = "_a3-2";
export var title = "_a3-1";
export var value = "_a3-0";